import React from "react";

function Footer() {
  return (
    <footer class="container home my-5 text-center">
      <p class="h3">&copy; Copyright 2023</p>
      <p class="h6 kidding">Just kidding not Copyrighted</p>
    </footer>
  );
}

export default Footer;
